import Components from "../components";
import FaultSearch from "./fault_search/fault_search";

class FaultFilter extends FaultSearch {
  bind() {
    super.bind();
    this.on(this.$input, "keypress", (e) => {
      const code = e.keyCode || e.which;
      if (code === 13) {
        this.finalizeInput();
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    });
  }

  finalizeInput() {
    this.hideHint();
    this.query.select(null);
    this.$input.blur();
    this.$input.trigger("blur");
    this.tokenDeleter.hideLink();
  }
}

Components.collection.register({
  selector: ".c-fault-filter",
  klass: FaultFilter,
});
